import _ from "lodash"

// test: jest src/models/__tests__/PreorderSetting.model.spec.js
export default class PreorderSetting {
  constructor(rawData) {
    this._rawData = rawData;
  }

  get branchSelectionIsEnabled() {
    return _.get(this._rawData, 'config.branch_select.is_enabled', false)
  }

  get shouldFilterProductByBranch() {
    return this.branchSelectionIsEnabled && _.get(this._rawData, 'config.product_page.should_filter_product_by_branch', false)
  }

  get productStockIsEnabled() {
    return _.get(this._rawData, 'config.product_page.check_stock', false)
  }

  get productIsVisibleWhenOutOfStock() {
    if (false === this.productStockIsEnabled) {
      return true
    }

    return _.get(this._rawData, 'config.product_page.product_is_visible_when_out_of_stock', false)
  }

  get isPreorderMode() {
    return _.get(this._rawData, 'charge_mode', null) === null
  }

  get isMoneyMode() {
    return _.get(this._rawData, 'charge_mode', null) === 'money'
  }

  get isPointMode() {
    return _.get(this._rawData, 'charge_mode', null) === 'point'
  }

  get shouldDisplayMemberPoints() {
    return _.get(this._rawData, 'config.point_mode.show_point', false)
  }
}
